import { render, staticRenderFns } from "./PersonalOrderItem.vue?vue&type=template&id=741e143d&scoped=true&"
import script from "./PersonalOrderItem.vue?vue&type=script&lang=js&"
export * from "./PersonalOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./PersonalOrderItem.vue?vue&type=style&index=0&id=741e143d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741e143d",
  null
  
)

export default component.exports